module.exports = __webpack_public_path__ + "img/twitter-icon.58bf128.svg";